import logger from './logger';
  // // Formatting
//import jsPDF from 'jspdf';

const BASE_URL = process.env.REACT_APP_API_URL;

// export function formatTimePlusFiveHours(inputTime) {
//   // Convert input to Date object
//   const originalDate = new Date(inputTime);

//   // // Add 5 hours
//   // const adjustedDate = new Date(originalDate.getTime() + 5 * 60 * 60 * 1000);

//   // // Format to HH:mm AM/PM

//   const options = {
//     hour: '2-digit',
//     minute: '2-digit',
//     hour12: true,
//   };

//   return originalDate.toLocaleString(undefined, options); //'en-US', options
// }

/**
 * Convert UTC datetime from database to local Date object
 * Handles various datetime formats from MySQL
 * @param {string} utcDatetime - UTC datetime string from database
 * @returns {Date} - Date object in local timezone
 */
export const convertUTCToLocal = (utcDatetime) => {
  if (!utcDatetime) return null;

  let utcString = utcDatetime;

  // If it's already a Date object, return it
  if (utcDatetime instanceof Date) {
    return utcDatetime;
  }

  // Ensure timezone indicator for proper UTC parsing
  // MySQL returns datetime without timezone, so we need to add 'Z'
  if (typeof utcString === 'string' && !utcString.includes('Z') && !utcString.includes('+') && !utcString.includes('-', 10)) {
    // Replace space with 'T' to ensure proper ISO 8601 format
    utcString = utcString.replace(' ', 'T') + 'Z';
  }

  return new Date(utcString);
};

/**
 * Convert local Date object to UTC ISO string for database storage
 * @param {Date} localDate - Local Date object
 * @returns {string} - UTC ISO string
 */
export const convertLocalToUTC = (localDate) => {
  if (!localDate) return null;
  
  if (!(localDate instanceof Date)) {
    localDate = new Date(localDate);
  }
  
  return localDate.toISOString();
};

/**
 * Format UTC datetime from database for display
 * @param {string} utcDatetime - UTC datetime string from database
 * @param {object} options - Intl.DateTimeFormat options
 * @returns {string} - Formatted datetime string in local timezone
 */
export const formatUTCForDisplay = (utcDatetime, options = {}) => {
  const date = convertUTCToLocal(utcDatetime);
  if (!date) return '';
  
  const defaultOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  };
  
  return new Intl.DateTimeFormat('en-US', { ...defaultOptions, ...options }).format(date);
};

/**
 * Format UTC date (without time) from database for display
 * @param {string} utcDate - UTC date string from database
 * @returns {string} - Formatted date string
 */
export const formatDateForDisplay = (utcDate) => {
  const date = convertUTCToLocal(utcDate);
  if (!date) return '';
  
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(date);
};

/**
 * Format UTC datetime for time only display
 * @param {string} utcDatetime - UTC datetime string from database
 * @returns {string} - Formatted time string (e.g., "2:00 PM")
 */
export const formatTimeForDisplay = (utcDatetime) => {
  const date = convertUTCToLocal(utcDatetime);
  if (!date) return '';
  
  return new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }).format(date);
};

/**
 * Get appointment time range for display
 * @param {string} startUTC - Appointment start time from database
 * @param {string} endUTC - Appointment end time from database
 * @returns {string} - Formatted time range (e.g., "2:00 PM - 3:00 PM")
 */
export const formatAppointmentTimeRange = (startUTC, endUTC) => {
  const start = formatTimeForDisplay(startUTC);
  const end = formatTimeForDisplay(endUTC);
  
  if (!start || !end) return '';
  
  return `${start} - ${end}`;
};
export const formatAppointmentDate = (startUTC) => {
  if (!startUTC) return '';

  const date = new Date(startUTC);
  if (isNaN(date)) return '';

  const month = String(date.getMonth() + 1).padStart(2, '0'); // 0‑based
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};

export function formatTimePlusFiveHours(inputTime) {
  const originalDate = new Date(inputTime);
  const adjustedDate = new Date(originalDate.getTime() + 6 * 60 * 60 * 1000);


  const options = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'America/Chicago', // or 'America/New_York', etc.
  };

  return adjustedDate.toLocaleString('en-US', options);
}

export function formatDateForAPI(dateObj) {
  if (!dateObj || !(dateObj instanceof Date)) return null;

  // Format to YYYY-MM-DD
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(dateObj.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function formatForDatetimeLocal(isoString) {
  if (!isoString) return ""; // Prevent errors from undefined/null

  const date = new Date(isoString);
  if (isNaN(date.getTime())) return ""; // Prevent malformed dates

  const offset = date.getTimezoneOffset() * 60000; // Adjust for local time
  const localISO = new Date(date - offset).toISOString().slice(0, 16);
  return localISO;
};

export function formatDatetimeForAPI(dateObj) {
  if (!dateObj || !(dateObj instanceof Date)) return null;

  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  const hours = String(dateObj.getHours()).padStart(2, '0');
  const minutes = String(dateObj.getMinutes()).padStart(2, '0');
  const seconds = String(dateObj.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
// export function formatToLocalDate(isoString) {
//   if (!isoString) return ""; // Handle undefined or null input

//   const date = new Date(isoString);
//   if (isNaN(date.getTime())) return ""; // Handle invalid dates

//   const offset = date.getTimezoneOffset() * 60000;
//   const localDate = new Date(date.getTime() - offset);

//   return localDate.toISOString().slice(0, 10); // Returns "YYYY-MM-DD"
// }

export function formatToLocalDate(isoString) {
  if (!isoString) return "";

  const date = new Date(isoString);
  if (isNaN(date.getTime())) return "";

  // Convert to local date string in YYYY-MM-DD format
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function formatTo12Hour(datetime) {
  if (datetime) {
    const date = new Date(datetime);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const formattedMinutes = minutes.toString().padStart(2, "0");
    return `${hours}:${formattedMinutes} ${ampm}`;
  } else {
      return("no time")
    }
};

export function sanitizeDateForInput(dateValue) {
  if (!dateValue) return '';
  try {
    return new Date(dateValue).toISOString().split('T')[0];
  } catch {
    return '';
  }
}

export function dateOfBirth(birthday) { 
    // logger.log(birthday)
    if(birthday){

    const dob = birthday.split("T")[0];
    const parts = dob.split("-");
    const newDate = `${parts[1]}/${parts[2]}/${parts[0]}`;
  
    return newDate;
     } else {
      return("No date")
    }
};
export function formatDateOfBirth(birthday) { 
    // logger.log(birthday)
    if(birthday){
    const dob = birthday.split(" ")[0];
    const parts = dob.split("-");
    const newDate = `${parts[1]}/${parts[2]}/${parts[0]}`;
  
    return newDate;
    } else {
      return("No date")
    }
};


export function formatTimeZone(initTime) { 
    const rawDate = initTime.split("T")[0];
    const formattedDate = rawDate.replace("T", " ").split(".")[0];
  
    return formattedDate;
};

export function showNoteDate(date) {
  if (!date) {
    return new Date().toLocaleDateString(); // Return current date if null or undefined
  }
  try {
    return new Date(date).toLocaleDateString(); // Format the provided date
  } catch (e) {
    logger.error("Error formatting date:", e);
    return new Date().toLocaleDateString(); // Fallback to current date on error
  }
};

export function invertDOB(birthday) {
  const dob = birthday.split("T")[0];
  const parts = dob.split("/");
  const newDate = `${parts[2]}-${parts[0]}-${parts[1]}`;
  return newDate;
};

export function numberedList(textData) {
      // Split the text data by '||' to create an array of items

  if(!textData){
    return("No data")
  } else {

  
  const items = textData.split("||");

  return (
    <div>
      <ol>
        {/* Map through the items and render each as an <li> */}
        {items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ol>
    </div>
  );
  }
};
export function capitalize(word) {
  if(word){
    return(word.charAt(0).toUpperCase() + word.slice(1));
  }
  else{
    return("No word");
  }
}
export function convertUTCToCentral(utcTime) {
  try {
    const date = new Date(utcTime);
    const options = {
      timeZone: "America/Chicago",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };
    
    // Format to "yyyy-MM-dd HH:mm:ss"
    const formatter = new Intl.DateTimeFormat("en-US", options);
    const parts = formatter.formatToParts(date);
    const year = parts.find(p => p.type === "year").value;
    const month = parts.find(p => p.type === "month").value;
    const day = parts.find(p => p.type === "day").value;
    const hour = parts.find(p => p.type === "hour").value;
    const minute = parts.find(p => p.type === "minute").value;
    const second = parts.find(p => p.type === "second").value;
    
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  } catch (error) {
    logger.error("Invalid UTC time:", utcTime, error);
    return null;
  }0
};

export function numberToLetter(number) {
  if (number >= 1 && number <= 26) {
    return String.fromCharCode(number + 64); // 65 is the ASCII code for 'A'
  }
  return ''; // Or handle out-of-range numbers differently
}

// export async function uploadToBucket(pdfBlob) {

//     const formData = new FormData();
//     formData.append('file', pdfBlob, `HealthHub_${Date.now()}.pdf`);

//     try {
//         const response = await fetch('/upload/pdf', { // Ensure this endpoint exists in your backend
//             method: 'POST',
//             body: formData,
//         });

//         if (!response.ok) {
//             throw new Error(`Failed to upload PDF: ${response.statusText}`);
//         }

//         logger.log('PDF uploaded successfully');
//     } catch (error) {
//         logger.error('Error uploading PDF:', error);
//         throw error;
//     }
// };

export function getUserId(user) {
  if(!user) return null;

  return (
    user.biller_id ||
    user.admin_id ||
    user.clinicians_id ||
    user.patients_id ||
    user.office_assistants_id ||
    user.medical_assistant_id ||
    user.rad_tech_id ||
    user.lab_tech_id ||
    null
  );
}

export function formatPhoneNumber(value) {
  const digits = value.replace(/\D/g, '').slice(0, 10); // Strip non-digits and limit to 10
  const match = digits.match(/^(\d{3})(\d{3})(\d{4})$/);
  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : value;
}

export function unformatPhoneNumber(value) {
  return value.replace(/\D/g, '').slice(0, 10); // Strip non-digits and limit to 10
}


// export async function uploadToBucket(pdfBlob, id, order_id, order_type) {
//     const formData = new FormData();
//     // const date = new Date();
//     // const formattedDate = dateOfBirth(date);
//     formData.append('file', pdfBlob, `HealthHub_${order_id}_${id}_${order_type}_results.pdf`);
//     // formData.append('appointment_id', appointment_id);

//     try {
//         const response = await fetch(`${BASE_URL}/upload/pdf`, { // Ensure this endpoint exists in your backend
//             method: 'POST',
//             body: formData
//         });

//         if (!response.ok) {
//             throw new Error(`Failed to upload PDF: ${response.statusText}`);
//         }

//         logger.log('PDF uploaded successfully');
//     } catch (error) {
//         logger.error('Error uploading PDF:', error);
//         throw error;
//     }
// }

export async function uploadToBucket(pdfBlob, location, id, clinic_note_id, type, user, folder_name) {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const formData = new FormData();
    // const date = new Date();
    // const formattedDate = dateOfBirth(date);
    if (location === 'lab') {
      formData.append('file', pdfBlob, `HealthHub_${clinic_note_id}_${id}_${location}.pdf`);
    } else {
      formData.append('file', pdfBlob, `HealthGuardian_${clinic_note_id}_${id}_${location}.pdf`);
    }
      // formData.append('appointment_id', appointment_id);

    const params = new URLSearchParams({
      folder_name: folder_name,
      user: user,
      type: type
    });

    try {
        const response = await fetch(`${BASE_URL}/upload/pdf?${params}`, { // Ensure this endpoint exists in your backend
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            throw new Error(`Failed to upload PDF: ${response.statusText}`);
        }

        // logger.log('PDF uploaded successfully');

    } catch (error) {
        logger.error('Error uploading PDF:', error);
        throw error;
    }
}

export async function uploadOrderToBucket(pdfBlob, document_id, type, user) {
    const formData = new FormData();
    // const date = new Date();
    // const formattedDate = dateOfBirth(date);
    formData.append('file', pdfBlob, `HealthGuardian_${document_id}.pdf`);
    // formData.append('appointment_id', appointment_id);
    const folder_name = 'RIS_ORDERS/'

    // logger.log('type: ', type, '\nuser: ', user)

    const params = new URLSearchParams({
      folder_name: folder_name,
      user: user,
      type: type
    });

    try {
        const response = await fetch(`${BASE_URL}/upload/pdf?${params}`, { // Ensure this endpoint exists in your backend
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            throw new Error(`Failed to upload PDF: ${response.statusText}`);
        }

        // logger.log('PDF uploaded successfully');

        return true;
    } catch (error) {
        logger.error('Error uploading PDF:', error);
        throw error;
    }
}

/**
 * Upload pending documents for a newly created patient
 * @param {string} sessionId - The session ID for the pending documents
 * @param {number} ris_patients_id - The newly created patient ID
 * @param {string} type - User type
 * @param {number} user - User ID
 * @returns {Promise<Object>} - Results of upload operations
 */
export async function uploadPendingDocuments(sessionId, ris_patients_id, type, user, order_id, order_type) {
  try {
    // Get pending documents from sessionStorage
    const stored = sessionStorage.getItem(`pending_docs_${sessionId}`);
    if (!stored) {
      return { success: true, count: 0, message: 'No pending documents to upload' };
    }

    const pendingDocuments = JSON.parse(stored);
    if (pendingDocuments.length === 0) {
      return { success: true, count: 0, message: 'No pending documents to upload' };
    }

    const results = {
      success: true,
      count: pendingDocuments.length,
      uploaded: [],
      failed: []
    };

    // Upload each pending document
    for (const pendingDoc of pendingDocuments) {
      try {
        // Convert base64 back to File object
        const response = await fetch(pendingDoc.fileData);
        const blob = await response.blob();
        const file = new File([blob], pendingDoc.file_name, { type: pendingDoc.fileType });

        // Step 1: Create document record in database
        const documentResponse = await fetch(`${BASE_URL}/upload/orders`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            file_name: pendingDoc.file_name,
            ris_patients_id: ris_patients_id,
            size: pendingDoc.size,
            user: user,
            type: type,
            order_id: order_id || null,
            order_type: order_type || null
          }),
        });

        if (!documentResponse.ok) {
          throw new Error('Failed to save document metadata');
        }

        const documentId = await documentResponse.json();

        // Step 2: Upload to GCS bucket
        const uploadSuccess = await uploadOrderToBucket(file, documentId, type, user);

        if (!uploadSuccess) {
          throw new Error('Failed to upload to bucket');
        }

        results.uploaded.push({
          file_name: pendingDoc.file_name,
          document_id: documentId
        });

      } catch (error) {
        // File name may embed patient identifiers; keep it out of the message.
        logger.error('Failed to upload pending document', error);
        results.failed.push({
          file_name: pendingDoc.file_name,
          error: error.message
        });
        results.success = false;
      }
    }

    // Clear pending documents from sessionStorage after upload attempt
    sessionStorage.removeItem(`pending_docs_${sessionId}`);

    return results;
  } catch (error) {
    logger.error('Error uploading pending documents:', error);
    return {
      success: false,
      count: 0,
      uploaded: [],
      failed: [],
      error: error.message
    };
  }
}

export async function uploadFollowUpNoteToBucket(pdfBlob, noteId, type, user, retries = 3) {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const folder_name = 'RIS_Follow-Up_Notes/';
  const fileName = `HealthGuardian_FollowUp_${noteId}.pdf`;

  const params = new URLSearchParams({ folder_name, type, user });

  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      const formData = new FormData();
      formData.append('file', pdfBlob, fileName);

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 60000);

      const response = await fetch(`${BASE_URL}/upload/pdf?${params}`, {
        method: 'POST',
        body: formData,
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Upload failed (${response.status}): ${errorText}`);
      }
      return;
    } catch (error) {
      logger.error(`Upload attempt ${attempt} failed:`, error);
      if (attempt === retries) throw error;
      await new Promise(resolve => setTimeout(resolve, 1000 * attempt));
    }
  }
}

/**
 * Distribute an amount (in cents) across weighted line items (combined-collection
 * allocation). `weights` is an array of { payment_id, schedule_id, amount } where `amount`
 * is the per-appointment balance used as the weight. Returns the same shape with each
 * `amount` set to its proportional share of `amountCents`; the last entry absorbs rounding
 * so the shares sum exactly to `amountCents`.
 */
export const allocateAmount = (weights, amountCents) => {
  if (!Array.isArray(weights) || weights.length === 0) return [];
  const total = Math.max(0, Math.round(amountCents));
  const sum = weights.reduce((s, w) => s + (Number(w.amount) || 0), 0) || 1;
  let acc = 0;
  return weights.map((w, i) => {
    const share = (i === weights.length - 1)
      ? total - acc
      : Math.round(total * (Number(w.amount) || 0) / sum);
    acc += share;
    return { payment_id: w.payment_id, schedule_id: w.schedule_id, amount: share };
  });
};

/**
 * Amount still owed for an appointment: the current bill total minus everything paid toward
 * it, floored at zero (a prior overpayment is a credit, never a negative balance).
 *
 * Payments are recorded for the correct (already-discounted) amount, so this simple aggregate
 * is accurate for every normal flow: partial payments, full payment, and add-ons collected
 * later — the add-on raises the total, and paying it brings the balance back to zero.
 *
 * NOTE: with only an aggregate "amount paid" (no per-line payment allocation) a genuine prior
 * overpayment is treated as a credit toward later add-ons rather than billed separately.
 * True per-item billing on top of an existing credit would require per-charge allocation.
 */
export const computeBalanceDue = (charges, totalPaid) => {
  if (!charges) return 0;
  const total = Number(charges.total) || 0;
  const paid = Number(totalPaid) || 0;
  return Math.max(0, Number((total - paid).toFixed(2)));
};

/**
 * Format a fax timestamp for display: "MM/DD/YYYY h:mm AM/PM" in the clinic's timezone.
 *
 * The DB stores these as UTC DATETIMEs and mysql2 serializes them to ISO strings, so they must
 * be rendered in America/Chicago rather than the browser's zone — a tech reading "2:14 PM"
 * needs it to mean 2:14 PM at the clinic no matter where the browser thinks it is.
 *
 * Returns '' for null/undefined/unparseable input so callers can render nothing.
 */
export const formatFaxTimestamp = (value) => {
  if (!value) return '';
  // mysql2 hands these back as Date objects (the pool is pinned to +00:00), which serialize to
  // ISO-with-Z. Guard the bare "YYYY-MM-DD HH:mm:ss" form too: JS parses that as LOCAL time,
  // which would shift the reading by 5–6 hours. These columns are always UTC.
  const raw = typeof value === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)
    ? `${value.replace(' ', 'T')}Z`
    : value;
  const date = new Date(raw);
  if (isNaN(date.getTime())) return '';
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: 'numeric', minute: '2-digit', hour12: true,
    }).formatToParts(date);
    const get = (t) => parts.find((p) => p.type === t)?.value || '';
    return `${get('month')}/${get('day')}/${get('year')} ${get('hour')}:${get('minute')} ${get('dayPeriod')}`;
  } catch {
    return '';
  }
};

/**
 * The timing line shown under a radiology order's fax status badge.
 *
 * The two columns mean different things and must not be conflated:
 *   - `faxed_at`            — set only when iFax CONFIRMS delivery (fax_status → sent).
 *   - `fax_last_attempt_at` — set on every submit attempt, so it is the right "when did we
 *                             last try" for a queued or failed fax.
 *
 * Returns { text, title } for the line, or null when there is nothing meaningful to show
 * (never faxed, or the timestamp is missing).
 *
 * @param {Object} order - radiology order row (fax_status, faxed_at, fax_last_attempt_at, fax_error)
 */
export const describeFaxTiming = (order) => {
  if (!order) return null;
  const status = order.fax_status || 'not_requested';
  const delivered = formatFaxTimestamp(order.faxed_at);
  const attempted = formatFaxTimestamp(order.fax_last_attempt_at);

  if (status === 'sent') {
    // Prefer the confirmed-delivery time; fall back to the submit time for rows recorded
    // before faxed_at was captured, and label it honestly as a submit time.
    if (delivered) return { text: `Delivered ${delivered}`, title: `iFax confirmed delivery at ${delivered}` };
    if (attempted) return { text: `Sent ${attempted}`, title: `Submitted to iFax at ${attempted} (no delivery timestamp recorded)` };
    return null;
  }

  if (status === 'queued') {
    if (!attempted) return null;
    return { text: `Submitted ${attempted}`, title: `Submitted to iFax at ${attempted} — awaiting delivery confirmation` };
  }

  if (status === 'failed') {
    if (!attempted) return null;
    return {
      text: `Last tried ${attempted}`,
      title: order.fax_error ? `Last attempt ${attempted}: ${order.fax_error}` : `Last attempt ${attempted}`,
    };
  }

  return null;   // not_requested — nothing has been tried
};

/**
 * fetch() with a hard time limit.
 *
 * A request that never settles freezes whatever UI is awaiting it — a spinner with no way out
 * but a page refresh. Browsers impose no default timeout, and a backend that logs an error
 * without sending a response will happily leave the socket open, so the client has to draw the
 * line itself.
 *
 * On timeout throws an Error with `name = 'TimeoutError'` and `timeout === true`, so callers can
 * tell "this took too long" apart from "the server said no".
 *
 * @param {string} url
 * @param {Object} [options]      - normal fetch options (a caller-supplied signal is respected)
 * @param {number} [timeoutMs]    - default 20s: generous enough for a Cloud Run cold start
 */
// Patient-location stages, in visit order. Kept here (rather than duplicated
// in CheckIn.js, LocationModal, and PatientAbout.js) so the dropdown, the
// stepper modal, and the location badge all agree on the same list/colors.
export const LOCATION_STAGES = [
  'Scheduled',
  'Registration',
  'Waiting room',
  'Lab',
  'Radiology',
  'Clinic 1',
  'Clinic 2',
  'Clinic 3',
  'Complete',
];

export const LOCATION_STAGE_COLORS = {
  'Scheduled': '#78909c',
  'Registration': '#fb8c00',
  'Waiting room': '#ffb300',
  'Lab': '#fdd835',
  'Radiology': '#1e88e5',
  'Clinic 1': '#43a047',
  'Clinic 2': '#43a047',
  'Clinic 3': '#43a047',
  'Complete': '#8e24aa',
};

export const getLocationStageColor = (location) => LOCATION_STAGE_COLORS[location] || '#1e88e5';

// Pulls the seconds-elapsed-so-far for whichever stage is currently open
// (ongoing: true) out of a statusTimes array, so a client-side ticker can
// keep counting up between fetches instead of freezing at the last value.
export const ongoingSecondsForStatus = (statusDurations, status) => {
  const entry = (statusDurations || []).find((d) => d.status === status && d.ongoing);
  return entry ? entry.seconds : null;
};

export const fetchWithTimeout = async (url, options = {}, timeoutMs = 20000) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    return await fetch(url, { ...options, signal: controller.signal });
  } catch (err) {
    if (err && err.name === 'AbortError') {
      const timeoutErr = new Error(`Request timed out after ${Math.round(timeoutMs / 1000)}s`);
      timeoutErr.name = 'TimeoutError';
      timeoutErr.timeout = true;
      throw timeoutErr;
    }
    throw err;
  } finally {
    clearTimeout(timer);
  }
};
